import { getRequest, postRequest } from '@bo-apis/axios';

const deleteFileList = (payload) =>
  postRequest({
    url: '/api/v1/common/file/delete-file-list',
    data: payload,
  });

const uploadPublicFiles = (payload) =>
  postRequest({
    url: '/api/v1/common/file/upload-public',
    data: payload,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });

const uploadPublicTempFiles = (payload) =>
  postRequest({
    url: '/api/v1/common/file/upload-public-temp',
    data: payload,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });

const copyPublicFiles = (payload) =>
  postRequest({
    url: '/api/v1/common/file/copy-public',
    data: payload,
  });

const uploadProtectedFiles = (payload) =>
  postRequest({
    url: '/api/v1/common/file/upload-protected',
    data: payload,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });

const downloadFile = (fileId) =>
  getRequest({
    url: `/api/v1/common/file/download/${fileId}`,
  });

const downloadPoManual = () =>
  getRequest({
    url: `/api/v1/common/file/download-po-manual`,
  });

const getFileByFileId = (fileId) =>
  getRequest({
    url: `/api/v1/common/file/get-file-info/${fileId}`,
  });

const getPoManualInfo = () =>
  getRequest({
    url: `/api/v1/common/file/get-po-manual-info`,
  });

const getFileByGroupIdParam = (groupId) =>
  getRequest({ url: `/api/v1/common/file/get-group-info`, params: { groupId } });

const getMyAlarms = () => getRequest({ url: '/api/v1/system/alarm' }, { skipSpinner: true });

const changeReadStatus = (payload) => postRequest({ url: '/api/v1/system/alarm/change-alarm-status', data: payload });

const getJobGroups = (payload) => postRequest({ url: 'api/v1/common/auth/job-groups', data: payload });

const changeJobGroup = (payload) => postRequest({ url: 'api/v1/common/auth/change-job-group', data: payload });

const getFileNameList = (payload) =>
  postRequest({
    url: '/api/v1/common/zip-file/file-names',
    data: payload,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });

const uploadZipFile = (payload) =>
  postRequest({
    url: '/api/v1/common/zip-file/upload-public',
    data: payload,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });

export default {
  uploadProtectedFiles,
  uploadPublicFiles,
  uploadPublicTempFiles,
  copyPublicFiles,
  deleteFileList,
  getFileByGroupIdParam,
  downloadFile,
  getFileByFileId,
  getMyAlarms,
  changeReadStatus,
  getJobGroups,
  changeJobGroup,
  getFileNameList,
  downloadPoManual,
  getPoManualInfo,
  uploadZipFile,
};
